import React from 'react'

import Services from '../__components/Services'

const Page = ({ transition }) => (
  <Services />
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/services.js